import { render } from "./PopularDestinationsSection.vue?vue&type=template&id=93c9eb18&scoped=true"
import script from "./PopularDestinationsSection.vue?vue&type=script&lang=js"
export * from "./PopularDestinationsSection.vue?vue&type=script&lang=js"

import "./PopularDestinationsSection.vue?vue&type=style&index=0&id=93c9eb18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93c9eb18"]])

export default __exports__